import { evaluate } from "mathjs";

// Utility to pick a random item from an array
function getRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function expandTemplate(templateObj, count = 10) {
    const { template, variables, generate, answerFormula, subtopic, ...rest } = templateObj;
    const questions = [];
  
    const seenEquations = new Set(); // NEW: to track uniqueness
    let attempts = 0;
  
    while (questions.length < count && attempts < count * 10) {
      attempts++; // Avoid infinite loops
  
      const values = {};
      for (const key of Object.keys(variables)) {
        values[key] = getRandom(variables[key]);
      }
  
      if (generate) {
        Object.assign(values, generate(values, questions.length));
      }
  
      let questionLatex = template;
      Object.entries(values).forEach(([key, val]) => {
        questionLatex = questionLatex.replaceAll(`{{${key}}}`, val);
      });
  
      if (seenEquations.has(questionLatex)) continue; // Skip duplicates
      seenEquations.add(questionLatex); // Track it
  
      let firstLine = "";
      if (subtopic?.toLowerCase().includes("expand")) {
        firstLine = "Expand:";
      } else if (subtopic?.toLowerCase().includes("solve")) {
        firstLine = "Solve for \\( x \\):";
      }
  
      let answer = "";
      try {
        if (answerFormula) {
          answer = evaluate(answerFormula, values).toString();
        } else if (values.answer) {
          answer = values.answer;
        } else {
          answer = "N/A";
        }
      } catch {
        answer = "Error";
      }
  
      questions.push({
        ...rest,
        ...values,
        subtopic: subtopic || "No Subtopic",
        type: "short-answer",
        question: questionLatex,
        textLines: [firstLine, questionLatex],
        answer,
      });
    }
  
    return questions;
  }
  